import { render, staticRenderFns } from "./IrInvoiceOrderMsbcRunner.vue?vue&type=template&id=9f50af80&"
import script from "./IrInvoiceOrderMsbcRunner.vue?vue&type=script&lang=js&"
export * from "./IrInvoiceOrderMsbcRunner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports